import { useState } from 'react'
import { Box, Typography, SvgIcon, IconButton } from '@mui/material'
import { Close } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

import AlertIcon from '@hapana/shared/web/styles/assets/svgs/exclamation-circle.svg'

import { styles } from './impersonation-banner.styles'

const ImpersonationBanner = ({ staffUser, adminUser }) => {
  const { t } = useTranslation('core')
  const [isDismissed, setIsDismissed] = useState(false)

  const adminName = adminUser?.name || adminUser?.email

  if (isDismissed) {
    return null
  }

  return (
    <Box sx={styles.container}>
      <SvgIcon component={AlertIcon} sx={styles.icon} />
      <Typography sx={styles.text}>
        {t('impersonation.banner.message', { adminName, name: staffUser?.name })}
      </Typography>
      <IconButton
        size="small"
        aria-label={t('common:close')}
        onClick={() => setIsDismissed(true)}
        sx={styles.dismiss}
        data-testid="impersonation-banner-close"
      >
        <Close fontSize="small" />
      </IconButton>
    </Box>
  )
}

export default ImpersonationBanner
